module.exports = __webpack_public_path__ + "img/twitter.8f5476c4.svg";